import { PublicKey } from '@solana/web3.js'

import { getSolUSDCTokenAccount } from '@src/chains/solana/utils'
import { IExchangeData } from '@src/types/exchange'
import { INetwork } from '@src/types/network'
import { isSolanaAddress } from '@src/utils/address'
import { addressToBytes32 } from '@src/utils/addressBytes32'
import { mapTokenAddress } from '@src/utils/tokenAddressMapping'

// Solana Exchange Utilities
export const solanaExchangeUtils = {
    getSwapFunctionParameters: async (
        walletAddress: string | undefined,
        sellData: IExchangeData,
        buyData: IExchangeData,
        availableNetworks: Record<string, INetwork>,
        flattened: boolean = false
    ) => {
        if (!walletAddress || !isSolanaAddress(walletAddress)) {
            throw new Error('Invalid solana wallet address')
        }

        const mintRecipient = await getSolUSDCTokenAccount(new PublicKey(walletAddress))

        if (!mintRecipient) {
            throw new Error('Invalid solana wallet USDC address')
        }

        const destinationAddressInBytes32 = addressToBytes32(mintRecipient.toBase58(), buyData.chainId, true)
        const amount = sellData.value || BigInt(0)

        if (flattened) {
            return [
                { type: 'uint256', value: amount.toString() },
                { type: 'uint32', value: availableNetworks[buyData.chainId].cctp_id.toString() },
                { type: 'bytes32', value: destinationAddressInBytes32 },
                { type: 'address', value: mapTokenAddress(sellData.token.address, false, sellData.chainId) },
            ]
        }

        return [
            amount,
            availableNetworks[buyData.chainId].cctp_id,
            destinationAddressInBytes32,
            mapTokenAddress(sellData.token.address, false, sellData.chainId),
        ]
    },
}
